import React, { useState } from "react";
import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";
import ReactNumeric from "../../../components/ReactNumeric/ReactNumeric";

export const FormaPrima = ({ primas }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    const periodo = id => {
        let ret;
        id = (id || 7).toString();
        switch (id) {
            case "1":
                ret = "MENSUAL";
                break;
            case "2":
                ret = "BIMENSUAL";
                break;
            case "3":
                ret = "TRIMESTRAL";
                break;
            case "4":
                ret = "CORRIENTE";
                break;
            case "5":
                ret = "DIFERIDO";
                break;
            case "6":
                ret = "INMEDIATO";
                break;
            case "0":
                ret = "INMEDIATO";
                break;
            default:
                ret = "";
                break;
        }
        return ret;
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Forma Prima"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <Table className="adjusttd text-center">
                                <thead className="text-primary">
                                    <tr>
                                        <th className={"text-left"}>Item</th>
                                        <th className={"text-left"}>Forma</th>
                                        <th className={"text-rigth"}>Valor</th>
                                        <th className={"text-left"}>Período Prima</th>
                                        <th className={"text-rigth"}>Costo Tarjeta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {primas.length === 0 ? (
                                        <React.Fragment>
                                            <tr>
                                                <td colSpan={5}>
                                                    <span>No hay información disponible.</span>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {primas.map((item, index) => (
                                                <tr key={item.cdFormaPrima}>
                                                    <td>
                                                        <span>{index + 1}</span>
                                                    </td>
                                                    <td className="text-left" style={{ maxWidth: 180 }}>
                                                        <span>{item.dscRubro}</span>
                                                    </td>
                                                    <td className="text-rigth " style={{ maxWidth: 20 }}>
                                                        <ReactNumeric
                                                            valuex={item.valFormaPrima ? item.valFormaPrima : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right "
                                                        />
                                                    </td>
                                                    <td className="text-rigth" style={{ maxWidth: 100 }}>
                                                        <span>{periodo(item.periodo)}</span>
                                                    </td>
                                                    <td className="text-right" style={{ maxWidth: 100 }}>
                                                        <span>
                                                            <ReactNumeric
                                                                valuex={item.valTarjeta ? item.valTarjeta : 0}
                                                                readOnly
                                                                className="form-control-plaintext text-right"
                                                            />
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
